import { Partial } from '@40seas/entities/common';
import { CreateIdentityDecisionDto } from './create-identity-decision.dto';

export class UpdateIdentityDecisionDto extends Partial(CreateIdentityDecisionDto) {}
